module.exports = __webpack_public_path__ + "img/aeroland-software-image-06.4e4fba81.png";